import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { ExternalLink, ImageOff, ArrowLeft } from 'lucide-react'
import { getClients } from '../api/clients'
import styles from './Portfolio.module.css'

function Portfolio() {
  const [clients, setClients] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getClients()
      .then(setClients)
      .catch(() => {})
      .finally(() => setLoading(false))
  }, [])

  return (
    <main className={styles.page}>
      <Link to="/" className={styles.homeBtn}><ArrowLeft size={14} />Back to Home</Link>
      <h1 className={styles.heading}>Our Clients</h1>
      <p className={styles.subtitle}>Businesses and individuals we've had the pleasure of working with.</p>

      {loading ? (
        <p className={styles.loading}>Loading…</p>
      ) : clients.length === 0 ? (
        <p className={styles.empty}>No clients to display yet.</p>
      ) : (
        <div className={styles.grid}>
          {clients.map((c) => (
            <div key={c.id} className={styles.card}>
              {c.thumbnail ? (
                <img src={c.thumbnail} alt={c.name} className={styles.thumbnail} />
              ) : (
                <div className={styles.thumbnailPlaceholder}>
                  <ImageOff size={32} />
                </div>
              )}
              <div className={styles.info}>
                <span className={styles.name}>{c.name}</span>
                {c.website_address ? (
                  <a
                    href={c.website_address}
                    target="_blank"
                    rel="noreferrer"
                    className={styles.websiteLink}
                  >
                    <ExternalLink size={13} />
                    {c.website_address.replace(/^https?:\/\//, '')}
                  </a>
                ) : (
                  <span className={styles.noWebsite}>No website</span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </main>
  )
}

export default Portfolio
